import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { SummaryTextField } from '../style';

const DynamicExposureComponent = ({ dynamicFields, currencyValue }) => {
  return (
    <Grid container spacing={2}>
      {dynamicFields.map(x => {
        return (
          <Grid key={x.id} item xs={12} sm={3}>
            <SummaryTextField isNumeric disabled fullWidth value={x.value * currencyValue || 0} label={x.label} />
          </Grid>
        );
      })}
    </Grid>
  );
};

DynamicExposureComponent.propTypes = {
  dynamicFields: PropTypes.array.isRequired,
  currencyValue: PropTypes.number
};

export default DynamicExposureComponent;
